import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        topHeading: {
            marginTop: 12,
            marginBottom: 8,
            marginLeft: 16,
            fontSize: 16,
            fontWeight: 600,
        },
        statusHeading: {
            fontSize: 16,
            fontWeight: 600,
            color: '#D6D000',
        },
        numberHeading: {
            fontSize: 10,
            opacity: 0.6,
            marginLeft: 8,
            marginTop: 5,
        },
        time: { 
            fontSize: 10,
            opacity: 0.6,
        },
        heading: {
            marginLeft: 8,
            fontSize: 14,
            fontWeight: 400,
        },
        primaryContainer: {
            display: 'flex', 
            justifyContent: 'space-between',  
            flexDirection: 'row',
            alignItems: 'center',
        },
        statusNumberContainer: {
            display: 'flex', 
            justifyContent: 'space-between',  
            flexDirection: 'row',
            alignItems: 'left',
        },
        description: {
            marginLeft: 8,
            marginTop:3,
            fontSize: 12,
            opacity: 0.7,
        },
        info: {
            marginLeft: 8,
            fontSize: 14,
            fontWeight: 400,
        },
        secondaryHolder: {
            display: 'flex',
            flexDirection: 'column',
        },
        secondaryContainer: {
            display: 'flex',
            flexDirection: 'row',
            fontSize: 12,
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        buttonHolder: {
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            marginTop: 16,
            marginBottom: 8,
        },
        declineButton: {
            textTransform: 'capitalize',
            padding: 10,
            fontSize: 13,
            opacity: 0.8,
            width: 168,
            height: 30,
            marginRight: 8,
            fontWeight: 500,
            borderColor: '#C64C27',
        },
        acceptButton: {
            textTransform: 'capitalize',
            padding: 10,
            fontSize: 13,
            opacity: 0.8,
            width: 168,
            height: 30,
            marginRight: 8,
            fontWeight: 500,
            borderColor: '#1CCB2D',
        },
        totalText: {
            marginLeft: 16,
            fontSize: 14,
            fontWeight: 400,
        },
        priceText: {
            marginRight: 16,
            fontSize: 14,
            fontWeight: 400,
        },
    }),
);